import React, {useState} from 'react';
import { IconButton } from '@material-ui/core'

// NOTE // a simple xit button that takes in an exit-function that receives a bool (false)
export const ExitButton = (props) => {
  let exitFunction = props.exit && typeof props.exit === 'function' ? props.exit : ''
  const [buttonColor, setButtonColor] = useState('#919090')

  return (
    <IconButton
      variant="contained"
      size="small"
      style={{ fontWeight: "bold", borderRadius: "0px", height: "30%", marginTop: "3px", color: buttonColor, textTransform: "none"}}
      onMouseEnter={() => {setButtonColor('#404040')}}
      onMouseLeave={() => {setButtonColor('#919090')}}
      onClick={() => {exitFunction()}}
    >
      x
    </IconButton>
  )
}